module.exports = "/assets/data/dbf2a323c84d31cd18fac73819dec982-SK11.data.json";